<template>
	<div>
		<div class="position-relative">
			<!-- shape Hero -->
			<section class="section-shaped">
				<div class="shape shape-style-1 shape-primary shape-skew">
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div>
				<div class="container shape-container d-flex">
					<div class="col px-0">
						<div class="row">
							<div class="col-lg-12">
								<h1 class="display-3 text-white">7-я Традиция АА</h1>
								<p class="lead  text-white">
									«Когда же мы выказываем щедрость, опуская деньги в шляпу, это служит признаком нашей благодарности за проявленное к нам
									милосердие и свидетельством острого желания поделиться тем, что мы обрели, со все ещё страдающими алкоголиками.»<br />
									<cite class="description">«Язык сердца», стр.221</cite>
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- 1st Hero Variation -->
		</div>
		<section class="section section-lg pt-lg-0" style="margin-top: -220px">
			<div class="container">
				<div class="row row-grid justify-content-center">
					<div class="col-lg-4">
						<card class="border-0" shadow body-classes="py-5">
							<h5 class="text-primary text-uppercase">
								<icon name="ni ni-building" type="primary" rounded class="mb-4"> </icon>
								&nbsp; PayPal
							</h5>
							<p class="mt-3">
								Если у вас есть счёт PayPal.<br />
								Или просто <b>Visa</b>/<b>Mastercard</b>.
							</p>
							<div>
								<badge type="primary" rounded>PayPal</badge>
								<badge type="primary" rounded>Visa</badge>
								<badge type="primary" rounded>Mastercard</badge>
							</div>
							<base-button tag="a" target="_pay" href="https://paypal.me/donateaa" type="primary" class="mt-4">
								Пожертвовать...
							</base-button>
						</card>
					</div>
					<div class="col-lg-4">
						<card class="border-0" shadow body-classes="py-5">
							<h5 class="text-success text-uppercase">
								<icon name="ni ni-world" type="success" rounded class="mb-4"> </icon>
								&nbsp; IBAN
							</h5>
							<p class="mt-3">
								Прямой перевод на счет в евро.<br />
								По номеру <b>IBAN</b>.
							</p>
							<div>
								<badge type="success" rounded>IBAN</badge>
								<badge type="success" rounded>Без комиссии</badge>
							</div>
							<base-button tag="a" target="_pay" href="#" type="success" class="mt-4" @click.prevent="modalIban = true">
								Пожертвовать...
							</base-button>
						</card>

						<modal :show.sync="modalIban" :modal-classes="{ 'modal-lg': 0 }" :modal-content-classes="{}">
							<template slot="header">
								<h5 class="modal-title" id="exampleModalLabel">
									Пока недоступно
								</h5>
							</template>
							<p>Если ты можешь использовать только этот способ, <router-link :to="{ name: 'contact' }">сообщи нам</router-link> об этом.</p>
							<p>
								Или выбери <a target="_pay" href="https://paypal.me/donateaa"><b>перевести через PayPal</b></a>
							</p>

							<template slot="footer">
								<base-button type="primary" @click="modalIban = false" :outline="true">Закрыть</base-button>
							</template>
						</modal>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'donate',
	data() {
		return { modalIban: false };
	},
	components: {},
};
</script>
<style lang="scss">
//@import "~bootstrap/scss/bootstrap";
//
.card {
	h6 + p {
		font-weight: 400;
	}
	//position: relative;
}

@media (max-width: 980px) {
	.section-lg {
		padding-top: 0 !important;
	}
}
</style>

